import { DropdownMenuItem } from 'twyne-new.ui';

export default function BuilderAction({ row, suffix = `${row.id}/builder` }) {
  const url = new URL(window.location.href)
  url.hostname = 'userenroll.com'
  url.pathname = `${url.pathname}/${suffix}`

  return <>
    <DropdownMenuItem disabled={!row.builder} onClick={() => window.open(url.href, '_blank')}>
      DnD Builder
    </DropdownMenuItem>
  </>
}
